import { AE } from './ae';
import { CO } from './co';
import { GB } from './gb';
import { GENERIC } from './generic';
import { PK } from './pk';
import { QA } from './qa';
import { SA } from './sa';
import { SUPPORTED_COUNTRIES, TAX_REGIME_CODES } from './types';
import { regimeAt } from './tax';
export * from './types';
export * from './identity';
export * from './formatting';
export * from './tax';
export * from './hijri';
export * from './phone';
export * from './names';
export { GENERIC as GENERIC_COUNTRY_PROFILE };
export const COUNTRY_PROFILES = { PK, SA, GB, CO, AE, QA };
export function countryProfile(code) {
    const supported = supportedCountryOrNull(code);
    return supported ? COUNTRY_PROFILES[supported] : GENERIC;
}
function basicsOf(profile) {
    return {
        code: profile.code,
        name: profile.name,
        timezone: profile.timezone,
        currency: profile.currency.code,
        taxRegime: regimeAt(profile, new Date()).code,
        readiness: profile.readiness === 'preview' ? 'preview' : 'ready',
    };
}
export const COUNTRY_BASICS = {
    PK: basicsOf(PK),
    SA: basicsOf(SA),
    GB: basicsOf(GB),
    CO: basicsOf(CO),
    AE: basicsOf(AE),
    QA: basicsOf(QA),
};
export function isSupportedCountry(value) {
    return typeof value === 'string' && SUPPORTED_COUNTRIES.includes(value);
}
export function supportedCountryOrNull(value) {
    if (!value)
        return null;
    const upper = value.trim().toUpperCase();
    return isSupportedCountry(upper) ? upper : null;
}
export function supportedCountryForTimezone(timezone) {
    if (!timezone)
        return null;
    return SUPPORTED_COUNTRIES.find((code) => COUNTRY_PROFILES[code].timezone === timezone) ?? null;
}
export function countryOfTenant(tenant) {
    return supportedCountryOrNull(tenant.country) ?? (tenant.country ? null : supportedCountryForTimezone(tenant.timezone));
}
export function currencyForCountry(country) {
    return COUNTRY_PROFILES[country].currency.code;
}
export function taxRegimeForCountry(country, at = new Date()) {
    return regimeAt(countryProfile(country), at).code;
}
export function isTaxRegimeCode(value) {
    return typeof value === 'string' && TAX_REGIME_CODES.includes(value);
}
//# sourceMappingURL=index.js.map